'use strict'

export default (mockAxios) => {
  // モバイルログイン設定の取得
  mockAxios.onGet(`/mbloginsettings`).reply(200, {
    'success': true,
    'data': {
      'mbcompanycodesave': '0',
      'mbloginidsave': '0',
      'mbloginpwdsave': '0',
      'mbloginsidterm': 60
    }
  })

  // モバイルログイン設定の更新
  mockAxios.onPut(`/mbloginsettings`).reply(200, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/mbLoginSettingRepositoryMock.js